import { useCallback, useRef } from 'react';

/**
 * Tracks the loading state of multiple child components and notifies the parent
 * via a single callback. Uses a ref for the callback to avoid cascading re-renders
 * when the parent provides a new function reference.
 */
export const useAggregateLoading = (onChangeLoadingState?: (isLoading: boolean) => void) => {
  const loadingStatesRef = useRef<Record<string, boolean>>({});
  const callbackRef = useRef(onChangeLoadingState);
  callbackRef.current = onChangeLoadingState;

  const track = useCallback((id: string, isLoading: boolean) => {
    loadingStatesRef.current[id] = isLoading;
    callbackRef.current?.(Object.values(loadingStatesRef.current).some(Boolean));
  }, []);

  return { track };
};
